import { render, staticRenderFns } from "./CalendarNavigation.vue?vue&type=template&id=0a277bd4&"
import script from "./CalendarNavigation.vue?vue&type=script&lang=js&"
export * from "./CalendarNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CalendarNavigation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VIcon,VLayout})
